<!--
 * @Description: 员工管理/设置权限
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-06-27 15:36:09
 * @LastEditTime: 2019-07-26 18:41:47
 -->
<template>
  <section class="addRecord-wrap">
    <el-form ref="form" :rules="rules" :model="fromInfo" label-width="7em">
      <el-row align="middle">
        <el-col :span="12" class="address">
          <el-form-item label="员工姓名：">
            {{ fromInfo.realName }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用户名：">
            {{ fromInfo.userName }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row align="middle">
        <el-col :span="12">
          <el-form-item label="级别管理：" prop="isAdmin" required>
            <el-select v-model="fromInfo.isAdmin" placeholder="请选择级别管理" @change="isAdminChange">
              <el-option v-for="(item, index) in dict.isAdmin" :key="index" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="职业类型：" prop="postType" required>
            <el-select v-model="fromInfo.postType" :disabled="postTypeIf" placeholder="请选择职业类型" required>
              <el-option v-for="(item, index) in dict.postType" :key="index" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注：" class="add-remarks" prop="remarks" required>
            <el-input v-model="fromInfo.remarks" type="textarea" />
            <span v-if="fromInfo.remarks">还可以输入{{ titleMaxLength - fromInfo.remarks.length }}个字</span>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="pop-btn" @click="Submission">
        保存
      </div>
    </el-form>
  </section>
</template>
<script>
import { getDict } from '@/api/common'
export default {
  props: {
    // 回显数据
    popData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 获取用户信息
    usertype: {
      type: [String, Object, Number],
      default: ''
    }
  },
  data() {
    return {
      dict: {
        isAdmin: [],
        postType: []
      },
      // 正则
      rules: {
        // 备注
        remarks: [{ required: true, message: '必填' }]
      },
      fromInfo: {
        isAdmin: '',
        remarks: '',
        userName: '',
        postType: ''
      },
      // 判断是否是编辑
      phoneIf: null,
      // 用户角色类型
      userType: this.usertype,
      // userAdmin
      userAdmin: false,
      // 职业类型 是否禁选
      postTypeIf: true,
      // 备注字数
      titleMaxLength: 255
    }
  },
  watch: {
    'fromInfo.remarks'() {
      if (this.fromInfo.remarks) {
        if (this.fromInfo.remarks.length > this.titleMaxLength) {
          this.fromInfo.remarks = String(this.fromInfo.remarks).slice(0, this.titleMaxLength)
        }
      }
    }
  },
  created() {
    this.fromInfo = JSON.parse(JSON.stringify(this.popData))
    const _this = this
    async function creat() {
      await _this.getDict('isAdmin')
      await _this.getDict('postType')
      // 获取类型 下拉列表
      _this.isAdminChange()
      // _this.screenFilter()
    }
    creat()
  },
  methods: {
    // 管理级别选中筛选
    isAdminChange(data) {
      console.log(data)
      this.userAdmin = true
      if (this.userType != '' && this.userAdmin == true) {
        this.postTypeIf = false
      }
      this.screenFilter()
    },
    // 获取字典
    getDict(type) {
      getDict(type).then(res => {
        this.dict[type] = JSON.parse(res.result)
      })
    },
    IfChoice(data) {
      console.log(data)
      this.dict.postType = data
      // 从新选中下拉
      this.fromInfo.postType = data[0].label
    },
    // 下拉筛选
    screenFilter() {
      if (this.userType == 2) {
        getDict('postType').then(res => {
          this.dict.postType = JSON.parse(res.result)
          if (this.fromInfo.isAdmin == 1) {
            const postFilter = this.dict.postType.filter(res => {
              return res.label == '经理'
            })
            // 从新赋值字典
            this.IfChoice(postFilter)
          } else if (this.fromInfo.isAdmin == 2) {
            const postFilter = this.dict.postType.filter(res => {
              return res.label == '行政管理' || res.label == '发布人员' || res.label == '网站管理员'
            })
            // 从新赋值字典
            this.IfChoice(postFilter)
          } else if (this.fromInfo.isAdmin == 3) {
            const postFilter = this.dict.postType.filter(res => {
              return res.label == '司机' || res.label == '押运人' || res.label == '普通职员'
            })
            // 从新赋值字典
            this.IfChoice(postFilter)
          }
        })
      } else {
        getDict('goodPostType').then(res => {
          this.dict.postType = JSON.parse(res.result)
          if (this.fromInfo.isAdmin == 1) {
            const postFilter = this.dict.postType.filter(res => {
              return res.label == '经理'
            })
            // 从新赋值字典
            this.IfChoice(postFilter)
          } else if (this.fromInfo.isAdmin == 2) {
            const postFilter = this.dict.postType.filter(res => {
              return res.label == '行政管理' || res.label == '发布人员' || res.label == '网站管理员'
            })
            // 从新赋值字典
            this.IfChoice(postFilter)
          } else if (this.fromInfo.isAdmin == 3) {
            const postFilter = this.dict.postType.filter(res => {
              return res.label == '普通员工'
            })
            // 从新赋值字典
            this.IfChoice(postFilter)
          }
        })
      }
    },
    Submission() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit('click', this.fromInfo)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import url('./staff.scss')
</style>
